import getPositionAbbreviation from './getPositionAbbreviation';
import getPlayerTeamCityAbbreviation from './getPlayerTeamCityAbbreviation';

const getPlayerSearchSubtitle = (player) => {
	if (!player) return '';

	const parts = [];

	if (player.position) {
		parts.push(getPositionAbbreviation(player.position));
	}

	const team = player.team;
	if (team?.location) {
		const abbreviation = getPlayerTeamCityAbbreviation(
			team.location,
			team.name
		);
		if (abbreviation) {
			parts.push(abbreviation);
		}
	}

	return parts.join(' · ');
};

export default getPlayerSearchSubtitle;
